// This is called a "splat route" and as it's in the root `/app/routes/`
// directory, it's a catchall. If no other routes match, this one will and we
// can know that the user is hitting a URL that doesn't exist. By throwing a
// 404 from the loader, we can force the error boundary to render which will
// ensure the user gets the right status code and we can display a nicer error
// message for them than the Remix and/or browser default.

import { useLocation } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'

export async function loader() {
	throw new Response('Not found', { status: 404 })
}

export default function NotFound() {
	// due to the loader, this component will never be rendered, but we'll return
	// the error boundary just in case.
	return <ErrorBoundary />
}

export function ErrorBoundary() {
	const location = useLocation()
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: () => (
					<div className="flex flex-col items-center justify-center px-8 text-center">
						<img
							src="/img/scl_logo.png"
							alt="Storycraft Lab"
							className="mb-8 h-16 w-auto"
						/>
						<div className="rounded-lg bg-white p-8 shadow-lg">
							<h1 className="mb-2 font-serif text-2xl font-medium text-gray-900">
								Page Not Found
							</h1>
							<p className="text-lg text-gray-600">
								We couldn't find this page:
							</p>
							<pre className="mt-2 rounded bg-gray-50 p-3 font-mono text-sm text-gray-800">
								{location.pathname}
							</pre>
							<p className="mt-6 text-sm text-gray-500">
								Please check the URL or navigate back to the home page.
							</p>
						</div>
					</div>
				),
			}}
		/>
	)
}
